<template>
    <div>
        <div class="header-wrapper">
            <header class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </header>
        </div>
        <div class="main">
            <div class="bg-white">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col col-lg-8">
                            <div class="content-box">
                                <div class="content-header">
                                    <h1 class="content-title">{{$t('meta.integrations.h1')}}</h1>
                                    <span class="content-subtitle-medium pt-4">{{$t('public.integrations.main_description')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="brand-section">
                    <div class="container">
                        <ul class="nav">
                            <li class="nav-item"
                                v-for="(item, index) in shops"
                                :key="item.title"
                                :style="'left: ' + sliderWidth * index  + '%; width: ' + sliderWidth + '%;'"
                            >
                                <a class="nav-link" @click="changeShop(index)">
                                    <img :src="`/static/brand/integration/${item.logo}`" :class="{'multicolor': activeShopIndex == index}" :alt="$t('meta.integrations.h1')"  :title="$t('meta.integrations.h1')">
                                </a>
                            </li>
                        </ul>
                        <div class="brand-section-text">
                            <div class="brand-section-text-title" v-text="shops[activeShopIndex].title"></div>
                            <div class="brand-section-text-text" v-html="shops[activeShopIndex].text"></div>
                            <router-link v-if="shops[activeShopIndex].link" :to="{name: shops[activeShopIndex].link}" class="blue-base-link mt-2 d-inline-block">{{shops[activeShopIndex].info}}</router-link>
                        </div>
                        <img class="bg-logo" src="~img/logo-gray.png" :alt="$t('meta.integrations.h1')"  :title="$t('meta.integrations.h1')">
                    </div>
                </div>
            </div>
            <div class="full">
                <div class="full-background"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-8">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="full-info">
                                        <div>
                                            <h4 class="full-info-title">{{$t('public.integrations.block.title')}}</h4>
                                            <div v-html="$t('public.integrations.block.text')"></div>
                                        </div>
                                        <router-link :to="{name: 'Advantages'}" class="full-info-link">{{$t('public.integrations.block.btn')}}</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="full-img">
                    <img src="~img/integracija-3-SMALL.jpg" :alt="$t('meta.integrations.h1')"  :title="$t('meta.integrations.h1')">
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <h2 class="h2-title mt-5">{{$t('public.integrations.info1.title')}}</h2>
                        <p>{{$t('public.integrations.info1.text')}}</p>
                        <div class="card-columns">
                            <ol>
                                <li v-html="$t('public.integrations.info1.list[0]')"></li>
                                <li v-html="$t('public.integrations.info1.list[1]')"></li>
                                <li v-html="$t('public.integrations.info1.list[2]')"></li>
                                <li v-html="$t('public.integrations.info1.list[3]')"></li>
                                <li v-html="$t('public.integrations.info1.list[4]')"></li>
                                <li v-html="$t('public.integrations.info1.list[5]')"></li>
                            </ol>
                        </div>
                        <article>
                            <h2 class="h2-title">{{$t('public.integrations.info2.title')}}</h2>
                            <p>{{$t('public.integrations.info2.text')}}</p>
                            <p><b>{{$t('public.integrations.info2.before_btn')}}<router-link :to="{name: 'AdditionalService'}">{{$t('public.integrations.info2.btn')}}</router-link>.</b></p>
                        </article>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'Integration',
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'integration'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        data() {
            return {
                shops: [
                    {logo: 'amazon.png', title: this.$t('public.integrations.shops.amazon.title'), link: 'Integration', info: this.$t('public.integrations.shops.amazon.info'), text: this.$t('public.integrations.shops.amazon.text')},
                    {logo: 'eBay.png', title: this.$t('public.integrations.shops.ebay.title'), link: 'Integration', info: this.$t('public.integrations.shops.ebay.info'), text: this.$t('public.integrations.shops.ebay.text')},
                    {logo: 'wooCommerce.png', title: this.$t('public.integrations.shops.woo_commerce.title'), text: this.$t('public.integrations.shops.woo_commerce.text')},
                    {logo: 'shopify.png', title: this.$t('public.integrations.shops.shopify.title'), link: 'Integration', info: this.$t('public.integrations.shops.shopify.info'), text: this.$t('public.integrations.shops.shopify.text')},
                    {logo: 'etsy.png', title: this.$t('public.integrations.shops.etsy.title'), text: this.$t('public.integrations.shops.etsy.text')},
                    {logo: 'magento.png', title: this.$t('public.integrations.shops.magento.title'), text: this.$t('public.integrations.shops.magento.text')},
                    {logo: 'prestaShop.png', title: this.$t('public.integrations.shops.presta_shop.title'), text: this.$t('public.integrations.shops.presta_shop.text')}
                ],
                sliderTiming: null
            }
        },
        computed: {
            sliderWidth() {
                return 100 / (this.shops.length)
            },
            activeShopIndex() {
                return Math.round(this.shops.length / 2 - 1)
            }
        },
        metaInfo() {
            return {
                title: this.$t('meta.integrations.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.integrations.description') },
                ]
            }
        },
        methods: {
            startSlider() {
                this.sliderTiming = setInterval(() => {
                    this.scrollShop(this.activeShopIndex + 1)
                }, 6000)
            },
            scrollShop(newIndex) {
                if (newIndex > this.activeShopIndex) {
                    let firstItem = {}
                    Object.assign(firstItem, this.shops[0])
                    this.shops.splice(0, 1)
                    this.$set(this.shops, this.shops.length, firstItem)
                }
                if (newIndex < this.activeShopIndex) {
                    let lastItem = {}
                    Object.assign(lastItem, this.shops[this.shops.length - 1])
                    this.shops.splice(this.shops.length - 1, 1)
                    this.shops.unshift(lastItem)
                }
            },
            changeShop(newIndex) {
                clearInterval(this.sliderTiming)
                if (newIndex > this.activeShopIndex) {
                    let scrollTimes = newIndex - this.activeShopIndex
                    for (let i = 1; i <= scrollTimes; i++) {
                        setTimeout(() => {
                            this.scrollShop(this.activeShopIndex + i)
                        }, 100)
                    }
                }
                if (newIndex < this.activeShopIndex) {
                    let scrollTimes = this.activeShopIndex - newIndex
                    for (let i = scrollTimes; i >= 0; i--) {
                        setTimeout(() => {
                            this.scrollShop(this.activeShopIndex - i)
                        }, 100)
                    }
                }
                this.startSlider()
            }
        },
        mounted() {
            this.startSlider()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/Integration.vue